import { Console } from "console";
import { ethers } from "ethers";
import { useEffect, useMemo, useState } from "react";
import Loader from "react-spinners/SquareLoader";
import styled from "styled-components";
import {
  ChevronLeft,
  ChevronRight,
  ThreeHundredSixty
} from "styled-icons/material";

import { useWeb3React } from "@web3-react/core";

import BackupGoat from "../../assets/gg-10.png";
import { useGnarlyGoatsContractsState } from "../../hooks/useGnarlyGoatsContracts";
import { usePrettyEthAddress } from "../../hooks/useHelpers";
import { Token, useTokens } from "../../hooks/usePaginatedTokens";
import { Emoji } from "../../theme";
import {
  Button,
  DashboardWrapper,
  ElementWrapper,
  ExternalLink,
  Interface,
  Text,
  Title
} from "../../theme/components";

const TokensWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 10px;
	grid-auto-rows: minmax(100px, auto);
	min-width: fit-content;
	border-sizing: border-box;
	margin: 2rem 0 0 0;
	${({ theme }) => theme.mediaWidth.upToSmall`
		grid-template-columns: repeat(2, 1fr);
  `};
`

const TokenImage = styled.img`
	width: 100%;
	height: auto;
	border-sizing: border-box;
	:hover {
		cursor: pointer;
	}
`

const CollectionDashboard = (props: any) => {
	const { accountBalance } = useGnarlyGoatsContractsState()

	const { tokens } = useTokens()

	const [tokenImages, setTokenImages] = useState<string[]>()

	const fetchTokenImages = async (tokens: Token[]) => {
		const fetchTokenImageData = Promise.all(
			tokens.map(async (token) => {
				const res = await fetch(token.tokenUrl)
				const imageBlob = await res.blob()
				const imageObjectURL = URL.createObjectURL(imageBlob)
				return imageObjectURL
			})
		)

		const response = await fetchTokenImageData

		setTokenImages(response)
	}

	useEffect(() => {
		if (!!tokens) {
			fetchTokenImages(tokens)
		}
	}, [tokens])

	/**
	 * generate array of token elements from token metadata
	 */
	const tokenElements = useMemo(() => {
		return tokens?.map((token: Token, index: number) => {
			const _src = tokenImages
				? tokenImages[index]
				: 'https://ipfs.gnarlygoats.com/ipfs/QmbqYZxN9FB7Cj2AA1aWV3qLkhqPe1ZwNqPb69WapDwngi'

			console.log(_src)

			if (!!tokenImages && tokenImages.length > 0) {
				return (
					<div key={token.tokenId}>
						<TokenImage
							alt={token.tokenId}
							src={_src}
							onClick={(e: any) => {
								window.open((e.target as HTMLImageElement).src)
							}}
							onLoad={() => {}}
						/>
						<Title color2 fontSize={12}>
							{`Gnarly Goat #${token.tokenId}`}
						</Title>
					</div>
				)
			} else {
				return (
					<Loader
						color="#2172E5"
						loading={true}
						size={100}
						css={`
							padding: 10px;
							margin: 1rem;
						`}
					/>
				)
			}
		})
	}, [tokens, tokenImages])

	return (
		<DashboardWrapper>
			{
				<Interface justifyContent="center">
					<Text raw primary3>
						Account Balance:
					</Text>
					<Text indent color2>{`${accountBalance} ${
						accountBalance === 1 ? 'Goat' : 'Goats'
					}`}</Text>
				</Interface>
			}

			{accountBalance > 0 && tokens && tokens.length > 0 && (
				<ElementWrapper>
					<TokensWrapper>{tokenElements}</TokensWrapper>
				</ElementWrapper>
			)}
		</DashboardWrapper>
	)
}

export default CollectionDashboard
